import React, {Component} from 'react'
import { connect } from 'react-redux'
import CryptoJS from 'crypto-js'
import User from '../../types/User'
import isAuthenticated from '../../routes/isAuthenticated'
import { Col, Card, Container, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { addUserActivity } from '../../redux/actions/authentication'
import './index.css'

interface Props {
  height: number;
  user: User;
  width:  number;
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number }, token: string ) => void;
}

class Contact extends Component<Props> {
  componentDidMount() {
    const { user, addUserActivity } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''

    addUserActivity({
      eid: email.eid,
      activity: 'View Contact'
    }, token)
  }

  render() {
    const {height, width} = this.props
		
    return(
      <Container 
        style={{
          paddingTop:20, 
          backgroundColor: '#f5f5f5', 
          width:width, 
          height:height-20, 
          maxWidth:width, 
          overflow:'auto'
        }}>
        <Row>
          <div className="contact-header">
            <div className="contact-header-txt">
              <div className="contact-icon">
                <FontAwesomeIcon icon={['fas', 'phone-square']} size="3x" />
              </div>
              <h3 className='contact-title'>Contact</h3>
            </div>
          </div>
        </Row>
        <Row>
          <Card style={{border:'none', width:width, height:height-120}}>
            <Card.Body>
              <div className='contact-table-container'>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4} sm={4} md={4} lg={4}>
                      <div className="contact-left-col">
												Topic
                      </div>
                    </Col>
                    <Col xs={8} sm={8} md={8} lg={8} className='contact-row-right'>
                      <div className="contact-right-col">
												Authorization Questions
                      </div>
                    </Col>
                  </Row>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4}>
                      <div className="contact-left-col">
												Contact
                      </div>
                    </Col>
                    <Col xs={8} className='contact-row-right'>
                      <div className="contact-right-col">
												Lakeland Care Team (Care Manager or RN)
                      </div>
                    </Col>
                  </Row>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4}>
                      <div className="contact-left-col">
												Phone
                      </div>
                    </Col>
                    <Col xs={8} className='contact-row-right'>
                      <div className="contact-right-col">
												As Listed on Authorization
                      </div>
                    </Col>
                  </Row>
                </Col>
              </div>
              <div className='contact-table-container'>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4} sm={4} md={4} lg={4}>
                      <div className="contact-left-col">
												Topic
                      </div>
                    </Col>
                    <Col xs={8} sm={8} md={8} lg={8} className='contact-row-right'>
                      <div className="contact-right-col">
												Contract Questions/Address Changes
                      </div>
                    </Col>
                  </Row>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4}>
                      <div className="contact-left-col">
												Contact
                      </div>
                    </Col>
                    <Col xs={8} className='contact-row-right'>
                      <div className="contact-right-col">
												Lakeland Provider Specialist
                      </div>
                    </Col>
                  </Row>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4}>
                      <div className="contact-left-col">
												Email
                      </div>
                    </Col>
                    <Col xs={8} className='contact-row-right'>
                      <div className="contact-right-col">
												network.relations@lakelandcareinc.com
                      </div>
                    </Col>
                  </Row>
                </Col>
              </div>
              <div className='contact-table-container'>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4} sm={4} md={4} lg={4}>
                      <div className="contact-left-col">
												Topic
                      </div>
                    </Col>
                    <Col xs={8} sm={8} md={8} lg={8} className='contact-row-right'>
                      <div className="contact-right-col">
												Claims/Denials/Appeals
                      </div>
                    </Col>
                  </Row>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4}>
                      <div className="contact-left-col">
												Contact
                      </div>
                    </Col>
                    <Col xs={8} className='contact-row-right'>
                      <div className="contact-right-col">
												Lakeland Claims
                      </div>
                    </Col>
                  </Row>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4}>
                      <div className="contact-left-col">
												Email
                      </div>
                    </Col>
                    <Col xs={8} className='contact-row-right'>
                      <div className="contact-right-col">	
												claims@lakelandcareinc.com
                      </div>
                    </Col>
                  </Row>
                </Col>
              </div>
              <div className='contact-table-container'>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4} sm={4} md={4} lg={4}>
                      <div className="contact-left-col">
												Topic
                      </div>
                    </Col>
                    <Col xs={8} sm={8} md={8} lg={8} className='contact-row-right'>
                      <div className="contact-right-col">
												General Questions
                      </div>
                    </Col>
                  </Row>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4}>
                      <div className="contact-left-col">
												Contact
                      </div>
                    </Col>
                    <Col xs={8} className='contact-row-right'>
                      <div className="contact-right-col">
												Lakeland Care
                      </div>
                    </Col>
                  </Row>
                  <Row className="contact-row">
                    <Col className="contact-left-col-row" xs={4}>
                      <div className="contact-left-col">
												Phone
                      </div>
                    </Col>
                    <Col xs={8} className='contact-row-right'>
                      <div className="contact-right-col">	
												920-906-5100
                      </div>
                    </Col>
                  </Row>
                </Col>
              </div>
            </Card.Body>
          </Card>
        </Row>
      </Container>
    )
  }
}

const mapStateToProps = (state: any) => ({
  user: state.authentication.user.data
})

const mapDispatchToProps = (dispatch: any) => ({
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number }, token: string ) => dispatch(addUserActivity(data, token))
})

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(Contact)
)